/**
 * Защита от CSRF по схеме Double Submit Cookie:
 * GET /api/accounts/session кладёт токен в cookie, небезопасные запросы
 * дублируют его в заголовке. Имена cookie и заголовка должны совпадать с бэкендом.
 */

const CSRF_COOKIE_NAME = 'csrftoken';

export const CSRF_HEADER_NAME = 'X-CSRFToken';

export function getCSRFToken(): string | null {
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === CSRF_COOKIE_NAME) {
      return decodeURIComponent(value);
    }
  }

  return null;
}

export function needsCSRFToken(method: string): boolean {
  const unsafeMethods = ['POST', 'PUT', 'PATCH', 'DELETE'];
  return unsafeMethods.includes(method.toUpperCase());
}
